import { Box, Button } from '@material-ui/core';
import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useHistory, useLocation } from 'react-router-dom';
import { mainishStyles } from '../../styling';
import { DialogCommon } from '../Common/DialogContext';
import {
  InputField,
  ReactHookFormComboBox,
  ReactHookFormDatePicker,
  ReactHookFormUpload,
} from '../Common/Form';
import { SnackbarAlert, useSnackBar } from '../Common/SnackBarContext';
import {
  majorsData,
  reqData,
  serviceData,
  TTLData,
  uploadData,
} from './formData';

export default function FormPengisian() {
  const location = useLocation();

  const formclasses = mainishStyles();
  const { handleSubmit, control, errors, register, trigger } = useForm({
    mode: 'onBlur',
    // defaultValues: {
    //   'Upload Image': location.state ? location.state['Upload Image'] : null,
    // },
  });
  const [loading, setLoading] = useState(false);
  const history = useHistory();

  const snackBarHelper = useSnackBar();

  const onSubmit = async (data) => {
    if (loading !== null) {
      setLoading(true);
    }
    try {
      history.push({ pathname: '/2', state: data });
    } catch (e) {
      snackBarHelper.openSnackBar('error', e.toString());
    }
  };

  return (
    <div>
      <form
        className={formclasses.formCommons}
        onSubmit={handleSubmit(onSubmit)}
      >
        <Box display="flex" flexWrap="noWrap" flexDirection="column">
          {reqData.map((data, i) => (
            <InputField
              key={i}
              type={data.type}
              attr={data.attr}
              defaultValue={location.state ? location.state[data.attr] : ''}
              rules={data.rules}
              register={register}
              error={errors[data.attr]}
            />
          ))}
        </Box>
        <Box display="flex" flexDirection="row" width="100%">
          {TTLData.map((data, i) =>
            data.type === 'date' ? (
              <ReactHookFormDatePicker
                key={i}
                attr={data.attr}
                defaultValue={location.state ? location.state[data.attr] : ''}
                rules={data.rules}
                error={errors[data.attr]}
                control={control}
                disableFuture
                openTo="year"
                fullWidth={true}
                style={{
                  marginRight: 0,
                }}
              />
            ) : (
              <InputField
                key={i}
                type={data.type}
                attr={data.attr}
                defaultValue={location.state ? location.state[data.attr] : ''}
                rules={data.rules}
                shrink={data.shrink}
                register={register}
                error={errors[data.attr]}
                fullWidth={true}
              />
            )
          )}
        </Box>
        <Box display="flex" flexWrap="noWrap" flexDirection="column">
          {majorsData.map((data, i) => (
            <ReactHookFormComboBox
              key={i}
              attr={data.attr}
              options={data.options}
              defaultValue={location.state ? location.state[data.attr] : null}
              rules={data.rules}
              error={errors[data.attr]}
              control={control}
              req={data.req}
            />
          ))}
          {serviceData.map((data, i) => (
            <ReactHookFormComboBox
              attr={data.attr}
              options={data.options}
              defaultValue={location.state ? location.state[data.attr] : null}
              key={i}
              rules={data.rules}
              error={errors[data.attr]}
              control={control}
              req={data.req}
            />
          ))}
          <ReactHookFormUpload
            req={uploadData[0].req}
            attr={uploadData[0].attr}
            rules={uploadData[0].rules}
            error={errors[uploadData[0].attr]}
            defaultValue={
              location.state ? location.state[uploadData[0].attr] : null
            }
            register={register}
            label={uploadData[0].label}
            acceptedType={uploadData[0].acceptedType}
            placeholder={'Unggah file Anda'}
            triggerValidation={trigger}
          />
          <Box
            style={{
              width: '100%',
              display: 'flex',
            }}
          >
            <Button
              type="submit"
              variant="contained"
              color="primary"
              style={{
                display: 'flex',
                marginRight: 0,
                marginLeft: 'auto',
              }}
            >
              Selanjutnya
            </Button>
          </Box>
        </Box>
      </form>
      <SnackbarAlert />
      <DialogCommon />
    </div>
  );
}
